import Image from "next/image";
import {EVENT_COPY} from "../content";
import css from "../mjbc-2026.module.scss";

const IMG = '/images/mjbc-2026';

/**
 * The ACTIVE × Small Circle lockup, pinned to the top of every frame.
 *
 * SERVED AS VECTOR, and this is the one image on the page that must not go
 * through VadImage. The optimiser rasterises whatever it is given, and only
 * downscales — `metaWidth > size` guards the resize — so an SVG whose intrinsic
 * box is 437x24 comes out of every single bucket as the same 437x24 bitmap. The
 * "1440w-2x" variant is byte-identical to the "480w-1x" one; both were 2,542
 * bytes of 437px-wide WebP, which the page then drew at 437 CSS px. That is
 * exactly 1x on a 1x screen and visibly soft on every retina display, which is
 * what made the logo look cheap next to the crisp type beside it.
 *
 * The source file is Figma's own export, unmodified — vector all the way down —
 * so shipping it as an SVG is both sharper at any density and the simpler
 * pipeline. `unoptimized` is belt and braces: next.config.ts already disables
 * the built-in optimiser globally, and Next refuses to process SVGs regardless.
 *
 * The wrapper is what gets positioned, not the image, so that
 * `position: absolute` never lands on the <img> itself and leaves it in flow as
 * a zero-height flex child claiming the stage's gap.
 */
export function Lockup() {
    return (
        <div className={css.lockup}>
            <Image
                src={`${IMG}/logo-active-x-small-circle.svg`}
                alt="ACTIVE × Small Circle"
                width={437}
                height={24}
                unoptimized
            />
        </div>
    );
}

/**
 * "— TOP SECRET TRANSMISSION FOR —" with the commander name beneath.
 *
 * The rules flank the label rather than sitting above it: desktop draws two
 * 163.86px rules either side of a 295px label, mobile two 25px rules either
 * side of a 178px one.
 */
export function TransmissionFooter({name}: {name: string}) {
    return (
        <footer className={css.transmission}>
            <p className={css.transmissionLabel}>
                <span className={css.transmissionRule} aria-hidden="true"/>
                <span>{EVENT_COPY.transmissionFor}</span>
                <span className={css.transmissionRule} aria-hidden="true"/>
            </p>
            <p className={css.transmissionName}>{name}</p>
        </footer>
    );
}
